module.exports = __webpack_public_path__ + "img/Skynet.e8cad2fd.png";